export default __webpack_public_path__ + "static/media/firebase.8896e25c.png";